<template>
	<div class="competition-info">
		<div class="information info-left" v-if="competitionInfo">
			<h4 class="info-name">{{competitionInfo.exam_ground_name}}</h4>
			<div class="info-con">
				<div class="info-author">出题人：{{'科技兔编程学院'}}</div>
				<div class="info-start-date">开始时间: {{competitionInfo.start_time}}</div>
				<div class="info-end-date">结束时间: {{competitionInfo.end_time}}</div>
				<div class="info-duration">比赛时长: {{competitionInfo.use_time}}</div>
				<div class="info-subject-num">总题数: {{competitionInfo.problem_count}}题</div>
				<div class="info-people-num">参加人数: {{competitionInfo.application_number}}人</div>
				<img class="info-end-icon" src="@/assets/img/simulationGame/yijieshu.png" alt="">
			</div>
		</div>
		<div class="information info-right" v-if="userInfo">
			<h4 class="info-name">我的成绩</h4>
			<div class="info-con">
				<template v-if="userInfo.join">
					<div class="info-score">总分：{{userInfo.score}}分</div>
					<div class="info-show-btn" @click="showExamination">查看试卷</div>
					<div class="info-ranking">第<div class="info-bg">
							<img v-if="userInfo.rank <= 3" class="info-ranking-bg"
								:src="require('@/assets/img/simulationGame/ranking'+userInfo.rank+'.png')" alt="">
							<span v-else class="info-place">{{userInfo.rank}}</span>
						</div>名</div>
					<div class="info-encourage">天才源于勤奋， <br>再接再厉，继续加油！</div>
				</template>
				<div v-else class="info-uncommitted">尚未参加本次比赛</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getExamGroundUserResult
	} from '@/api/simulationGame'
	export default {
		name: "competitionInfo",
		components: {},
		props: {
			examGroundId: String
		},
		data() {
			return {
				userInfo: null, // 个人成绩
				competitionInfo: null, // 试卷信息
			}
		},
		created() {
			this.getExamGroundUserResult();
		},
		mounted() {},
		watch: {},
		methods: {
			async getExamGroundUserResult() {
				let res = await getExamGroundUserResult({
					examGroundId: this.examGroundId
				});
				if (res.status) {
					this.userInfo = res.data.userInfo
					this.competitionInfo = res.data.examGroundInfo
				}
			},
			showExamination() { // 查看试卷
				this.$router.push({
					name: "competition",
					query: {
						examGroundId: this.examGroundId,
						type: 1
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.competition-info {
		display: flex;
		// height: 100%;

		.information {
			flex: 1;

			.info-name {
				font-size: 1.84rem;
				font-family: "Source Han Sans SC";
				font-weight: 500;
				color: #81FEFF;
				margin-top: 2rem;
				padding-left: 1.44rem;
			}

			.info-con {
				font-size: 1.48rem;
				font-family: "Source Han Sans SC";
				font-weight: 500;
				color: #FFFFFF;

				width: 32rem;
				height: 22rem;
				background: rgba(30, 44, 58, 0.6);
				border: 0.08rem solid #707882;
				border-radius: 0.4rem;
				position: relative;
				margin: 1.8rem auto;
				padding-bottom: 2rem;
			}
		}

		.info-left {
			position: relative;
			height: 100%;

			.info-con {
				.info-author {
					margin-top: 1.4rem;
				}

				.info-author,
				.info-start-date,
				.info-end-date,
				.info-duration,
				.info-subject-num,
				.info-people-num {
					line-height: 3.04rem;
					padding-left: 1.28rem;
				}

				.info-end-icon {
					width: 6.4rem;
					height: 5rem;
					position: absolute;
					right: 1.84rem;
					bottom: 4rem;
				}
			}

			&::after {
				content: '';
				position: absolute;
				width: 0.16rem;
				height: calc(100% - 1.44rem);
				background: #83ACD4;
				right: -0.08rem;
				top: 0.72rem;
			}
		}

		.info-right {
			.info-con {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				.info-score {
					margin-top: 1rem;
				}

				.info-show-btn {
					width: 6.8rem;
					height: 2.4rem;
					line-height: 2.4rem;
					text-align: center;
					background: #00E5FF;
					border-radius: 0.4rem;
					color: #003E5D;
					font-size: 1.28rem;
					position: absolute;
					top: 1.8rem;
					right: 1.8rem;
					cursor: pointer;
				}

				.info-ranking {
					display: flex;
					justify-content: center;
					align-items: center;
					margin-top: 4rem;

					.info-bg {
						margin: 0 2.8rem;
						background: #184256;
						border: 0.08rem solid #B2FFFF;
						border-radius: 50%;
						width: 7.6rem;
						height: 7.6rem;
						display: flex;
						justify-content: center;
						align-items: center;

						.info-ranking-bg {
							width: 6rem;
							height: 5.8rem;
							margin-right: 0.8rem;
							margin-top: 0.3rem;
						}

						.info-place {
							font-size: 2.68rem;
							color: #B0FF85;
						}
					}
				}

				.info-encourage {
					text-align: center;
					margin-top: 0.86rem;
					padding-left: 1rem;
				}

				.info-uncommitted {}
			}
		}
	}
</style>
